import * as React from 'react';
import { useRef, useState} from 'react';
import {
    Input, Button, Card, DialogContent, Divider, FormControl, FormLabel, 
    Stack, Typography, Box
} from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowDownAZ, faArrowUpAZ} from '@fortawesome/free-solid-svg-icons'
import RadioIconButtonGroup from '../RadioIconButtonGroup'
import ScheduleIcon from '@mui/icons-material/Schedule';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import GradeIcon from '@mui/icons-material/Grade';
import CountrySelect from '../CountrySelect';

import * as CONSTANTS from "../../constants"


const OrganizationFilter = ({resetFilter, submitFilter, lang}) => {

    // const [experience, setExperience] = useState([0, 11]);
    const [sortOption, setSortOption] = useState('a_to_z');
    const [name, setName] = useState('');
    const [country, setCountry] = useState(null);

    let tagKeys = []
    for (let index = 1; index < 11; index++) {
        tagKeys.push(index);
    }

    const ResetFilter = () => {
        setName('');
        setCountry(null);
        // setExperience([0, 11]);
        resetFilter();
    }
    
    const GetFilter = () => {
        let params = new URLSearchParams({});
        params.append('page', 1)
        if (country !== null && country.code !== '') params.append('country', country.code);
        if (name !== '')  params.append('name', name);
        // params.append('fromExp', experience[0]);
        // params.append('toExp', experience[1]);
        params.append('sort', sortOption);
        submitFilter(params);
    };

    const UpdateCountry = (event, newValue) => {
        setCountry(newValue);
    }

    return (
        <Card
            sx={{
                borderRadius: 'md',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                overflow: "auto",
                minWidth: "300px",
            }}
        >
            <Box sx={{ gap: 2 }}>
                <Stack
                    direction={'column'}
                    spacing={2}
                >
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold' }}>{CONSTANTS.WAZAREN_FILTER.SORTING_OPTION[lang]}</FormLabel>
                    <RadioIconButtonGroup 
                        hook={sortOption}
                        setHook={setSortOption}
                        buttonValues={[
                            'a_to_z', 'z_to_a', // 'experience', 'clicks', 'likes', 'ratings',
                        ]}
                        buttonIcons={{
                            'a_to_z': <FontAwesomeIcon icon={faArrowDownAZ} />,
                            'z_to_a': <FontAwesomeIcon icon={faArrowUpAZ} />,
                            'experience': <ScheduleIcon />,
                            'clicks': <VisibilityIcon />,
                            'likes': <ThumbUpIcon />,
                            'ratings': <GradeIcon />,
                        }}
                        buttonDisableds={{
                            'a_to_z': false,
                            'z_to_a': false,
                            'experience': false,
                            'clicks': true,
                            'likes': true,
                            'ratings': true
                        }}
                        tooltipValues={{
                            'a_to_z': 'Name (A to Z)',
                            'z_to_a': 'Name (Z to A)',
                            'experience': 'Experience',
                            'clicks': 'Clicks',
                            'likes': 'Likes',
                            'ratings': 'Ratings'
                        }}
                    />
                <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold'}}>{CONSTANTS.WAZAREN_FILTER.SEARCHING_OPTION[lang]}</FormLabel>
                <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold' }}>{CONSTANTS.ORGANIZATION_FILTER.NAME[lang]}</FormLabel>
                <Input 
                    placeholder={CONSTANTS.WOTAGEISHI_FILTER.NAME_PLACEHOLDER[lang]}
                    value={name}
                    onChange={(e)=> setName(e.target.value)}
                />

                <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold', mt: 1 }}>{CONSTANTS.WOTAGEISHI_FILTER.COUNTRY[lang]}</FormLabel>
                <FormControl>
                    <CountrySelect lang={lang} country={country} UpdateCountry={UpdateCountry} />
                </FormControl>

                <Divider sx={{ mt: 'auto' }} />
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    useFlexGap
                    spacing={1}
                >
                    <Button
                    variant="outlined"
                    color="neutral"
                    onClick={ResetFilter}
                    >
                    {CONSTANTS.WAZAREN_FILTER.RESET[lang]}
                    </Button>
                    <Button
                        variant='contained'
                        color="primary"
                        onClick={GetFilter}
                    >
                        {CONSTANTS.WAZAREN_FILTER.SEARCH[lang]}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    </Card>
  );
};

export default OrganizationFilter;
